import classNames from 'classnames';
import React, { forwardRef, LegacyRef, useEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import { IconType } from '@react-icons/all-files/lib';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

export const FormControl = forwardRef(
  (
    props: {
      label?: React.ReactNode;
      name: string;
      error?: FieldError;
      leftIcon?: IconType;
      rightIcon?: IconType;
      onRightIconClick?: () => void;
      children: React.ReactNode;
      className?: string;
      leftText?: string;
    } & Partial<UseFormRegisterReturn>,
    ref: LegacyRef<HTMLDivElement>,
  ) => {
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
      if (props.error?.message) {
        setErrorMessage(props.error.message);
      }
    }, [props.error]);

    const LeftIcon = props.leftIcon;
    const RightIcon = props.rightIcon;

    return (
      <div
        ref={ref}
        className={classNames('inline-block w-full', props.className)}
      >
        <label
          htmlFor={props.name}
          className={classNames(
            'block text-sm font-medium transition-all whitespace-nowrap',
            props.error ? 'text-red-600' : 'text-gray-700',
          )}
        >
          {props.label}
        </label>
        <div className="mt-1 relative">
          {LeftIcon && (
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
              <LeftIcon />
            </div>
          )}
          {props.children}
          {RightIcon && (
            <div
              className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-gray-400 hover:text-gray-600"
              onClick={(e) => {
                e.stopPropagation();
                props.onRightIconClick?.();
              }}
            >
              <RightIcon />
            </div>
          )}
        </div>
        <div className={errorMessage ? 'h-3 mt-1 relative' : ''}>
          <Transition
            appear
            enter="transition-opacity duration-75"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-75"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="text-red-600 text-xs absolute"
            show={!!props.error}
            data-test-id={`${props.name}-error-message`}
          >
            {errorMessage}
          </Transition>
        </div>
      </div>
    );
  },
);
